module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("azQtk"))).then(() => parcelRequire('hEqeo'));